export const APPLICATION_NAME = 'Industry Statistics Report';
export const APPLICATION_OWNER_NAME = 'Mississippi Surplus Lines Association';
export const APPLICATION_OWNER_SHORT_NAME = 'MSLA';

export const NOTIFICATION_LEVELS = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

// The default time a toast notification will be displayed before
// being automatically dismissed
export const NOTIFICATION_LIFESPAN = 6000;
